/** units of spacing in px */
export var DS_SHAPE_SPACING;
(function (DS_SHAPE_SPACING) {
    /** Basic unit */
    DS_SHAPE_SPACING[DS_SHAPE_SPACING["BASE"] = 4] = "BASE";
    /** Between section and next section */
    DS_SHAPE_SPACING[DS_SHAPE_SPACING["SECTION"] = 40] = "SECTION";
    /** Between title/heading and descriptive text */
    DS_SHAPE_SPACING[DS_SHAPE_SPACING["HEADING_DESCRIPTION"] = 8] = "HEADING_DESCRIPTION";
    /** Between heading and content on desktop */
    DS_SHAPE_SPACING[DS_SHAPE_SPACING["HEADING_CONTENT_DESKTOP"] = 24] = "HEADING_CONTENT_DESKTOP";
    /** Between heading and content on mobile */
    DS_SHAPE_SPACING[DS_SHAPE_SPACING["HEADING_CONTENT_MOBILE"] = 16] = "HEADING_CONTENT_MOBILE";
    /** Between pieces of related content */
    DS_SHAPE_SPACING[DS_SHAPE_SPACING["CONTENT"] = 24] = "CONTENT";
    /** Between edge of viewport and content > large breakpoint */
    DS_SHAPE_SPACING[DS_SHAPE_SPACING["SIDE_LARGE"] = 32] = "SIDE_LARGE";
    /** Between edge of viewport and content medium to large breakpoint */
    DS_SHAPE_SPACING[DS_SHAPE_SPACING["SIDE_MEDIUM"] = 24] = "SIDE_MEDIUM";
    /** Between edge of viewport and content small to medium breakpoint and below */
    DS_SHAPE_SPACING[DS_SHAPE_SPACING["SIDE_SMALL"] = 16] = "SIDE_SMALL";
})(DS_SHAPE_SPACING || (DS_SHAPE_SPACING = {}));
/** units of spacing in base spacing units */
export var DS_SPACING_UNITS;
(function (DS_SPACING_UNITS) {
    /** Basic unit */
    DS_SPACING_UNITS[DS_SPACING_UNITS["BASE"] = 1] = "BASE";
    /** Between section and next section */
    DS_SPACING_UNITS[DS_SPACING_UNITS["SECTION"] = 10] = "SECTION";
    /** Between title/heading and descriptive text */
    DS_SPACING_UNITS[DS_SPACING_UNITS["HEADING_DESCRIPTION"] = 2] = "HEADING_DESCRIPTION";
    /** Between heading and content on desktop */
    DS_SPACING_UNITS[DS_SPACING_UNITS["HEADING_CONTENT_DESKTOP"] = 6] = "HEADING_CONTENT_DESKTOP";
    /** Between heading and content on mobile */
    DS_SPACING_UNITS[DS_SPACING_UNITS["HEADING_CONTENT_MOBILE"] = 4] = "HEADING_CONTENT_MOBILE";
    /** Between pieces of related content */
    DS_SPACING_UNITS[DS_SPACING_UNITS["CONTENT"] = 6] = "CONTENT";
    /** Between edge of viewport and content > large breakpoint */
    DS_SPACING_UNITS[DS_SPACING_UNITS["SIDE_LARGE"] = 8] = "SIDE_LARGE";
    /** Between edge of viewport and content medium to large breakpoint */
    DS_SPACING_UNITS[DS_SPACING_UNITS["SIDE_MEDIUM"] = 6] = "SIDE_MEDIUM";
    /** Between edge of viewport and content small to medium breakpoint and below */
    DS_SPACING_UNITS[DS_SPACING_UNITS["SIDE_SMALL"] = 4] = "SIDE_SMALL";
})(DS_SPACING_UNITS || (DS_SPACING_UNITS = {}));
/** Heights of various elements in px */
export var DS_HEIGHT;
(function (DS_HEIGHT) {
    DS_HEIGHT[DS_HEIGHT["AVATAR_XXLARGE"] = 164] = "AVATAR_XXLARGE";
    DS_HEIGHT[DS_HEIGHT["AVATAR_XLARGE"] = 100] = "AVATAR_XLARGE";
    DS_HEIGHT[DS_HEIGHT["AVATAR_LARGE"] = 64] = "AVATAR_LARGE";
    DS_HEIGHT[DS_HEIGHT["AVATAR_MEDIUM"] = 48] = "AVATAR_MEDIUM";
    DS_HEIGHT[DS_HEIGHT["AVATAR_SMALL"] = 40] = "AVATAR_SMALL";
    DS_HEIGHT[DS_HEIGHT["BUTTON_LARGE"] = 48] = "BUTTON_LARGE";
    DS_HEIGHT[DS_HEIGHT["BUTTON_MEDIUM"] = 36] = "BUTTON_MEDIUM";
    DS_HEIGHT[DS_HEIGHT["BUTTON_SMALL"] = 32] = "BUTTON_SMALL";
    DS_HEIGHT[DS_HEIGHT["TOOLBAR"] = 64] = "TOOLBAR";
    DS_HEIGHT[DS_HEIGHT["TOOLBAR_MOBILE"] = 56] = "TOOLBAR_MOBILE";
    DS_HEIGHT[DS_HEIGHT["HORIZONTAL_CARD_SIZE"] = 116] = "HORIZONTAL_CARD_SIZE";
    DS_HEIGHT[DS_HEIGHT["BANNER_SIZE_SMALL"] = 88] = "BANNER_SIZE_SMALL";
    DS_HEIGHT[DS_HEIGHT["BANNER_SIZE_MEDIUM"] = 116] = "BANNER_SIZE_MEDIUM";
    DS_HEIGHT[DS_HEIGHT["BANNER_SIZE_LARGE"] = 140] = "BANNER_SIZE_LARGE";
})(DS_HEIGHT || (DS_HEIGHT = {}));
/** Heights of various elements in units of spacing */
export var DS_HEIGHT_UNITS;
(function (DS_HEIGHT_UNITS) {
    DS_HEIGHT_UNITS[DS_HEIGHT_UNITS["AVATAR_XLARGE"] = 25] = "AVATAR_XLARGE";
    DS_HEIGHT_UNITS[DS_HEIGHT_UNITS["AVATAR_LARGE"] = 16] = "AVATAR_LARGE";
    DS_HEIGHT_UNITS[DS_HEIGHT_UNITS["AVATAR_MEDIUM"] = 12] = "AVATAR_MEDIUM";
    DS_HEIGHT_UNITS[DS_HEIGHT_UNITS["AVATAR_SMALL"] = 10] = "AVATAR_SMALL";
    DS_HEIGHT_UNITS[DS_HEIGHT_UNITS["BUTTON_LARGE"] = 12] = "BUTTON_LARGE";
    DS_HEIGHT_UNITS[DS_HEIGHT_UNITS["BUTTON_MEDIUM"] = 9] = "BUTTON_MEDIUM";
    DS_HEIGHT_UNITS[DS_HEIGHT_UNITS["BUTTON_SMALL"] = 8] = "BUTTON_SMALL";
    DS_HEIGHT_UNITS[DS_HEIGHT_UNITS["TOOLBAR"] = 16] = "TOOLBAR";
    DS_HEIGHT_UNITS[DS_HEIGHT_UNITS["TOOLBAR_MOBILE"] = 14] = "TOOLBAR_MOBILE";
})(DS_HEIGHT_UNITS || (DS_HEIGHT_UNITS = {}));
/** Widths of various elements in px */
export var DS_WIDTH;
(function (DS_WIDTH) {
    DS_WIDTH[DS_WIDTH["BUTTON_MEDIUM"] = 140] = "BUTTON_MEDIUM";
    DS_WIDTH[DS_WIDTH["BUTTON_LARGE"] = 440] = "BUTTON_LARGE";
    DS_WIDTH[DS_WIDTH["FORM_MAX_WIDTH"] = 442] = "FORM_MAX_WIDTH";
})(DS_WIDTH || (DS_WIDTH = {}));
/** Heights of various elements in units of spacing */
export var DS_WIDTH_UNITS;
(function (DS_WIDTH_UNITS) {
    DS_WIDTH_UNITS[DS_WIDTH_UNITS["BUTTON_MEDIUM"] = 35] = "BUTTON_MEDIUM";
    DS_WIDTH_UNITS[DS_WIDTH_UNITS["BUTTON_LARGE"] = 110] = "BUTTON_LARGE";
})(DS_WIDTH_UNITS || (DS_WIDTH_UNITS = {}));
/** Used in border-radius in px */
export var DS_SHAPE_BORDER_RADIUS;
(function (DS_SHAPE_BORDER_RADIUS) {
    DS_SHAPE_BORDER_RADIUS[DS_SHAPE_BORDER_RADIUS["SMALL"] = 4] = "SMALL";
    DS_SHAPE_BORDER_RADIUS[DS_SHAPE_BORDER_RADIUS["MEDIUM"] = 8] = "MEDIUM";
    DS_SHAPE_BORDER_RADIUS[DS_SHAPE_BORDER_RADIUS["LARGE"] = 12] = "LARGE";
    DS_SHAPE_BORDER_RADIUS[DS_SHAPE_BORDER_RADIUS["CARD"] = 12] = "CARD";
    DS_SHAPE_BORDER_RADIUS[DS_SHAPE_BORDER_RADIUS["BUTTON_LARGE"] = 24] = "BUTTON_LARGE";
    DS_SHAPE_BORDER_RADIUS[DS_SHAPE_BORDER_RADIUS["BUTTON_MEDIUM"] = 18] = "BUTTON_MEDIUM";
    DS_SHAPE_BORDER_RADIUS[DS_SHAPE_BORDER_RADIUS["BUTTON_SMALL"] = 16] = "BUTTON_SMALL";
})(DS_SHAPE_BORDER_RADIUS || (DS_SHAPE_BORDER_RADIUS = {}));
/** Viewport breakpoints in px */
export var DS_BREAKPOINT;
(function (DS_BREAKPOINT) {
    /** Very small viewports */
    DS_BREAKPOINT[DS_BREAKPOINT["INTRA"] = 0] = "INTRA";
    /** Phones in portrait mode */
    DS_BREAKPOINT[DS_BREAKPOINT["SMALL"] = 320] = "SMALL";
    /** Tablet in portrait mode */
    DS_BREAKPOINT[DS_BREAKPOINT["MEDIUM"] = 600] = "MEDIUM";
    /** Phone in landscape, tablet in landscape, desktop */
    DS_BREAKPOINT[DS_BREAKPOINT["LARGE"] = 840] = "LARGE";
    /** Very large viewports, used to determine when a layout should stop expanding */
    DS_BREAKPOINT[DS_BREAKPOINT["ULTRA"] = 1440] = "ULTRA";
})(DS_BREAKPOINT || (DS_BREAKPOINT = {}));
/** Used in font-family  */
export const DS_FONT_FAMILY = '"Avenir Next", -apple-system, Arial, BlinkMacSystemFont, Helvetica Neue, Helvetica, sans-serif';
/** Used in font-size in px */
export var DS_FONT_SIZE;
(function (DS_FONT_SIZE) {
    DS_FONT_SIZE[DS_FONT_SIZE["H1"] = 96] = "H1";
    DS_FONT_SIZE[DS_FONT_SIZE["H2"] = 60] = "H2";
    DS_FONT_SIZE[DS_FONT_SIZE["H3"] = 48] = "H3";
    DS_FONT_SIZE[DS_FONT_SIZE["H4"] = 34] = "H4";
    DS_FONT_SIZE[DS_FONT_SIZE["H5"] = 24] = "H5";
    DS_FONT_SIZE[DS_FONT_SIZE["H6"] = 20] = "H6";
    DS_FONT_SIZE[DS_FONT_SIZE["AVATAR"] = 20] = "AVATAR";
    DS_FONT_SIZE[DS_FONT_SIZE["NORMAL_LARGE"] = 18] = "NORMAL_LARGE";
    DS_FONT_SIZE[DS_FONT_SIZE["NORMAL_MEDIUM"] = 16] = "NORMAL_MEDIUM";
    DS_FONT_SIZE[DS_FONT_SIZE["NORMAL_SMALL"] = 14] = "NORMAL_SMALL";
    DS_FONT_SIZE[DS_FONT_SIZE["BUTTON_LARGE"] = 15] = "BUTTON_LARGE";
    DS_FONT_SIZE[DS_FONT_SIZE["BUTTON_MEDIUM"] = 14] = "BUTTON_MEDIUM";
    DS_FONT_SIZE[DS_FONT_SIZE["BUTTON_SMALL"] = 13] = "BUTTON_SMALL";
    DS_FONT_SIZE[DS_FONT_SIZE["LABEL"] = 12] = "LABEL";
    DS_FONT_SIZE[DS_FONT_SIZE["TOOLTIP"] = 10] = "TOOLTIP";
})(DS_FONT_SIZE || (DS_FONT_SIZE = {}));
/** Used in letter-spacing */
export var DS_LETTER_SPACING;
(function (DS_LETTER_SPACING) {
    DS_LETTER_SPACING["L_2"] = "-1.5px";
    DS_LETTER_SPACING["L_1"] = "-0.5px";
    DS_LETTER_SPACING["L0"] = "0px";
    DS_LETTER_SPACING["L1"] = "0.1px";
    DS_LETTER_SPACING["L2"] = "0.14px";
    DS_LETTER_SPACING["L3"] = "0.15px";
    DS_LETTER_SPACING["L4"] = "0.25px";
    DS_LETTER_SPACING["L5"] = "0.4px";
    DS_LETTER_SPACING["L6"] = "0.46px";
    DS_LETTER_SPACING["L7"] = "1px";
})(DS_LETTER_SPACING || (DS_LETTER_SPACING = {}));
/** Used in font-weight */
export var DS_FONT_WEIGHT;
(function (DS_FONT_WEIGHT) {
    DS_FONT_WEIGHT[DS_FONT_WEIGHT["ULTRA_LIGHT"] = 100] = "ULTRA_LIGHT";
    DS_FONT_WEIGHT[DS_FONT_WEIGHT["LIGHT"] = 300] = "LIGHT";
    DS_FONT_WEIGHT[DS_FONT_WEIGHT["REGULAR"] = 400] = "REGULAR";
    DS_FONT_WEIGHT[DS_FONT_WEIGHT["MEDIUM"] = 500] = "MEDIUM";
    DS_FONT_WEIGHT[DS_FONT_WEIGHT["DEMI"] = 600] = "DEMI";
    DS_FONT_WEIGHT[DS_FONT_WEIGHT["BOLD"] = 700] = "BOLD";
    DS_FONT_WEIGHT[DS_FONT_WEIGHT["ULTRA_BOLD"] = 900] = "ULTRA_BOLD";
})(DS_FONT_WEIGHT || (DS_FONT_WEIGHT = {}));
/** Colors available to use in 6 or 8 digit hex */
export var DS_COLOR;
(function (DS_COLOR) {
    /**
     * LIGHT THEME
     */
    /* PRIMARY */
    DS_COLOR["LIGHT_PRIMARY_MAIN"] = "#0060A9";
    DS_COLOR["LIGHT_PRIMARY_DARK"] = "#00315B";
    DS_COLOR["LIGHT_PRIMARY_LIGHT"] = "#EAF1FF";
    DS_COLOR["LIGHT_PRIMARY_TEXT_CONTRAST"] = "#FFFFFF";
    // Same as LIGHT_PRIMARY_MAIN but with added transparency
    DS_COLOR["LIGHT_PRIMARY_4P"] = "#0060A980";
    DS_COLOR["LIGHT_PRIMARY_8P"] = "#0060A914";
    DS_COLOR["LIGHT_PRIMARY_12P"] = "#0060A91F";
    DS_COLOR["LIGHT_PRIMARY_30P"] = "#0060A94D";
    DS_COLOR["LIGHT_PRIMARY_50P"] = "#0060A980";
    /* SECONDARY */
    DS_COLOR["LIGHT_SECONDARY_MAIN"] = "#504CCB";
    DS_COLOR["LIGHT_SECONDARY_DARK"] = "#1E0C9E";
    DS_COLOR["LIGHT_SECONDARY_LIGHT"] = "#F2EFFF";
    DS_COLOR["LIGHT_SECONDARY_TEXT_CONTRAST"] = "#FFFFFF";
    // Same as LIGHT_SECONDARY_MAIN but with added transparency
    DS_COLOR["LIGHT_SECONDARY_4P"] = "#504CCB4D";
    DS_COLOR["LIGHT_SECONDARY_8P"] = "#504CCB14";
    DS_COLOR["LIGHT_SECONDARY_12P"] = "#504CCB1F";
    DS_COLOR["LIGHT_SECONDARY_30P"] = "#504CCB4D";
    DS_COLOR["LIGHT_SECONDARY_50P"] = "#504CCB80";
    /* ERROR */
    DS_COLOR["LIGHT_ERROR_MAIN"] = "#D14836";
    DS_COLOR["LIGHT_ERROR_DARK"] = "#AF3021";
    DS_COLOR["LIGHT_ERROR_LIGHT"] = "#FFEDEA";
    DS_COLOR["LIGHT_ERROR_TEXT_CONTRAST"] = "#FFFFFF";
    // Same as LIGHT_ERROR_MAIN but with added transparency
    DS_COLOR["LIGHT_ERROR_4P"] = "#D148364D";
    DS_COLOR["LIGHT_ERROR_8P"] = "#D1483614";
    DS_COLOR["LIGHT_ERROR_12P"] = "#D148361F";
    DS_COLOR["LIGHT_ERROR_30P"] = "#D148364D";
    DS_COLOR["LIGHT_ERROR_50P"] = "#D1483680";
    DS_COLOR["LIGHT_ERROR_160P"] = "#680100";
    DS_COLOR["LIGHT_ERROR_190P"] = "#FDE5EE";
    /* WARNING */
    DS_COLOR["LIGHT_WARNING_MAIN"] = "#B4611B";
    DS_COLOR["LIGHT_WARNING_DARK"] = "#954A00";
    DS_COLOR["LIGHT_WARNING_LIGHT"] = "#FFEDE4";
    DS_COLOR["LIGHT_WARNING_TEXT_CONTRAST"] = "#FFFFFF";
    // Same as LIGHT_WARNING_MAIN but with added transparency
    DS_COLOR["LIGHT_WARNING_4P"] = "#B4611B4D";
    DS_COLOR["LIGHT_WARNING_8P"] = "#B4611B14";
    DS_COLOR["LIGHT_WARNING_12P"] = "#B4611B1F";
    DS_COLOR["LIGHT_WARNING_30P"] = "#B4611B4D";
    DS_COLOR["LIGHT_WARNING_50P"] = "#B4611B80";
    DS_COLOR["LIGHT_WARNING_160P"] = "#551E00";
    DS_COLOR["LIGHT_WARNING_190P"] = "#F8EFE8";
    /* INFO */
    DS_COLOR["LIGHT_INFO_MAIN"] = "#007FB2";
    DS_COLOR["LIGHT_INFO_DARK"] = "#00658E";
    DS_COLOR["LIGHT_INFO_LIGHT"] = "#E5F3FF";
    DS_COLOR["LIGHT_INFO_TEXT_CONTRAST"] = "#FFFFFF";
    // Same as LIGHT_INFO_MAIN but with added transparency
    DS_COLOR["LIGHT_INFO_4P"] = "#007FB24D";
    DS_COLOR["LIGHT_INFO_8P"] = "#007FB214";
    DS_COLOR["LIGHT_INFO_12P"] = "#007FB21F";
    DS_COLOR["LIGHT_INFO_30P"] = "#007FB24D";
    DS_COLOR["LIGHT_INFO_50P"] = "#007FB280";
    DS_COLOR["LIGHT_INFO_160P"] = "#053347";
    DS_COLOR["LIGHT_INFO_190P"] = "#E5F2F7";
    /* SUCCESS */
    DS_COLOR["LIGHT_SUCCESS_MAIN"] = "#488600";
    DS_COLOR["LIGHT_SUCCESS_DARK"] = "#386B00";
    DS_COLOR["LIGHT_SUCCESS_LIGHT"] = "#D0FFA4";
    DS_COLOR["LIGHT_SUCCESS_TEXT_CONTRAST"] = "#FFFFFF";
    // Same as LIGHT_SUCCESS_MAIN but with added transparency
    DS_COLOR["LIGHT_SUCCESS_4P"] = "#4886004D";
    DS_COLOR["LIGHT_SUCCESS_8P"] = "#48860014";
    DS_COLOR["LIGHT_SUCCESS_12P"] = "#4886001F";
    DS_COLOR["LIGHT_SUCCESS_30P"] = "#4886004D";
    DS_COLOR["LIGHT_SUCCESS_50P"] = "#48860080";
    DS_COLOR["LIGHT_SUCCESS_160P"] = "#1E3600";
    DS_COLOR["LIGHT_SUCCESS_190P"] = "#EDF3E5";
    /* TEXT */
    DS_COLOR["LIGHT_TEXT_PRIMARY_HEADER"] = "#001C38";
    DS_COLOR["LIGHT_TEXT_SECONDARY_HEADER"] = "#0D006A";
    DS_COLOR["LIGHT_TEXT_DISABLED"] = "#00000061";
    DS_COLOR["LIGHT_TEXT_BODY"] = "#1A1A2C";
    DS_COLOR["LIGHT_TEXT_SUB"] = "#1A1A2CB2";
    /* ACTION */
    DS_COLOR["LIGHT_ACTION_ACTIVE"] = "#00000099";
    DS_COLOR["LIGHT_ACTION_HOVER"] = "#0000000A";
    DS_COLOR["LIGHT_ACTION_SELECTED"] = "#00000014";
    DS_COLOR["LIGHT_ACTION_DISABLED"] = "#00000042";
    DS_COLOR["LIGHT_ACTION_DISABLED_BACKGROUND"] = "#0000001F";
    DS_COLOR["LIGHT_ACTION_FOCUS"] = "#0000001F";
    /* BACKGROUND */
    DS_COLOR["LIGHT_BACKGROUND_PAPER"] = "#FFFFFF";
    DS_COLOR["LIGHT_BACKGROUND_DEFAULT"] = "#FFFFFF";
    DS_COLOR["LIGHT_BACKGROUND_PRIMARY_START"] = "#E2F6FF";
    DS_COLOR["LIGHT_BACKGROUND_PRIMARY_END"] = "#FDF7F9";
    DS_COLOR["LIGHT_BACKGROUND_SECONDARY_START"] = "#C2C1FF";
    DS_COLOR["LIGHT_BACKGROUND_SECONDARY_END"] = "#FFFBFF";
    /* MISC */
    DS_COLOR["LIGHT_DIVIDER"] = "#0000001A";
    DS_COLOR["LIGHT_OUTLINE_BORDER"] = "#0000003B";
    DS_COLOR["LIGHT_INPUT_LINE"] = "#0000006B";
    DS_COLOR["LIGHT_BACKDROP_OVERLAY"] = "#00000080";
    DS_COLOR["LIGHT_SNACKBAR_BACKGROUND"] = "#323232";
    DS_COLOR["LIGHT_FOCUS_OUTLINE"] = "#84FFFF";
    /**
     * DARK THEME
     */
    /* PRIMARY */
    DS_COLOR["DARK_PRIMARY_MAIN"] = "#FFFFFF";
    DS_COLOR["DARK_PRIMARY_DARK"] = "#A2C9FF";
    DS_COLOR["DARK_PRIMARY_LIGHT"] = "#EAF1FF";
    DS_COLOR["DARK_PRIMARY_TEXT_CONTRAST"] = "#000000CC";
    // Same as DARK_PRIMARY_DARK but with added transparency
    DS_COLOR["DARK_PRIMARY_8P"] = "#A2C9FF14";
    DS_COLOR["DARK_PRIMARY_12P"] = "#A2C9FF1F";
    DS_COLOR["DARK_PRIMARY_16P"] = "#A2C9FF29";
    DS_COLOR["DARK_PRIMARY_30P"] = "#A2C9FF4D";
    DS_COLOR["DARK_PRIMARY_50P"] = "#A2C9FF80";
    /* SECONDARY */
    DS_COLOR["DARK_SECONDARY_MAIN"] = "#F2EFFF";
    DS_COLOR["DARK_SECONDARY_DARK"] = "#C2C1FF";
    DS_COLOR["DARK_SECONDARY_LIGHT"] = "#FFFBFF";
    DS_COLOR["DARK_SECONDARY_TEXT_CONTRAST"] = "#000000DE";
    // Same as DARK_SECONDARY_DARK but with added transparency
    DS_COLOR["DARK_SECONDARY_8P"] = "#C2C1FF14";
    DS_COLOR["DARK_SECONDARY_12P"] = "#C2C1FF1F";
    DS_COLOR["DARK_SECONDARY_16P"] = "#C2C1FF1F29";
    DS_COLOR["DARK_SECONDARY_30P"] = "#C2C1FF4D";
    DS_COLOR["DARK_SECONDARY_50P"] = "#C2C1FF80";
    /* ERROR */
    DS_COLOR["DARK_ERROR_MAIN"] = "#FFB4A8";
    DS_COLOR["DARK_ERROR_DARK"] = "#680100";
    DS_COLOR["DARK_ERROR_LIGHT"] = "#FFEDEA";
    DS_COLOR["DARK_ERROR_TEXT_CONTRAST"] = "#FFFFFF";
    // Same as DARK_ERROR_MAIN but with added transparency
    DS_COLOR["DARK_ERROR_8P"] = "#FFB4A814";
    DS_COLOR["DARK_ERROR_12P"] = "#FFB4A81F";
    DS_COLOR["DARK_ERROR_30P"] = "#FFB4A84D";
    DS_COLOR["DARK_ERROR_50P"] = "#FFB4A880";
    DS_COLOR["DARK_ERROR_160P"] = "#FEE1DC";
    DS_COLOR["DARK_ERROR_190P"] = "#1A1211";
    /* WARNING */
    DS_COLOR["DARK_WARNING_MAIN"] = "#FFB785";
    DS_COLOR["DARK_WARNING_DARK"] = "#502500";
    DS_COLOR["DARK_WARNING_LIGHT"] = "#FFEDE4";
    DS_COLOR["DARK_WARNING_TEXT_CONTRAST"] = "#000000DE";
    // Same as DARK_WARNING_MAIN but with added transparency
    DS_COLOR["DARK_WARNING_8P"] = "#FFB78514";
    DS_COLOR["DARK_WARNING_12P"] = "#FFB7851F";
    DS_COLOR["DARK_WARNING_30P"] = "#FFB7854D";
    DS_COLOR["DARK_WARNING_50P"] = "#FFB78580";
    DS_COLOR["DARK_WARNING_160P"] = "#FEE2CE";
    DS_COLOR["DARK_WARNING_190P"] = "#1A120E";
    /* INFO */
    DS_COLOR["DARK_INFO_MAIN"] = "#85CFFF";
    DS_COLOR["DARK_INFO_DARK"] = "#001E2E";
    DS_COLOR["DARK_INFO_LIGHT"] = "#E5F3FF";
    DS_COLOR["DARK_INFO_TEXT_CONTRAST"] = "#000000DE";
    // Same as DARK_INFO_MAIN but with added transparency
    DS_COLOR["DARK_INFO_8P"] = "#85CFFF14";
    DS_COLOR["DARK_INFO_12P"] = "#85CFFF1F";
    DS_COLOR["DARK_INFO_30P"] = "#85CFFF4D";
    DS_COLOR["DARK_INFO_50P"] = "#85CFFF80";
    DS_COLOR["DARK_INFO_160P"] = "#CEECFF";
    DS_COLOR["DARK_INFO_190P"] = "#0D151B";
    /* SUCCESS */
    DS_COLOR["DARK_SUCCESS_MAIN"] = "#85DC33";
    DS_COLOR["DARK_SUCCESS_DARK"] = "#1A3700";
    DS_COLOR["DARK_SUCCESS_LIGHT"] = "#D0FFA4";
    DS_COLOR["DARK_SUCCESS_TEXT_CONTRAST"] = "#000000DE";
    // Same as DARK_SUCCESS_MAIN but with added transparency
    DS_COLOR["DARK_SUCCESS_8P"] = "#85DC3314";
    DS_COLOR["DARK_SUCCESS_12P"] = "#85DC331F";
    DS_COLOR["DARK_SUCCESS_30P"] = "#85DC334D";
    DS_COLOR["DARK_SUCCESS_50P"] = "#85DC3380";
    DS_COLOR["DARK_SUCCESS_160P"] = "#C0F2C8";
    DS_COLOR["DARK_SUCCESS_190P"] = "#0D1705";
    /* TEXT */
    DS_COLOR["DARK_TEXT_PRIMARY_HEADER"] = "#EAF1FF";
    DS_COLOR["DARK_TEXT_SECONDARY_HEADER"] = "#F2EFFF";
    DS_COLOR["DARK_TEXT_DISABLED"] = "#FFFFFF80";
    DS_COLOR["DARK_TEXT_BODY"] = "#FFFFFF";
    DS_COLOR["DARK_TEXT_SUB"] = "#FFFFFFB2";
    /* ACTION */
    DS_COLOR["DARK_ACTION_ACTIVE"] = "#FFFFFFCC";
    DS_COLOR["DARK_ACTION_HOVER"] = "#FFFFFF14";
    DS_COLOR["DARK_ACTION_SELECTED"] = "#FFFFFF29";
    DS_COLOR["DARK_ACTION_DISABLED"] = "#FFFFFF4D";
    DS_COLOR["DARK_ACTION_DISABLED_BACKGROUND"] = "#FFFFFF1F";
    DS_COLOR["DARK_ACTION_FOCUS"] = "#FFFFFF1F";
    /* BACKGROUND */
    DS_COLOR["DARK_BACKGROUND_PAPER"] = "#1A1A2C";
    DS_COLOR["DARK_BACKGROUND_DEFAULT"] = "#121212";
    DS_COLOR["DARK_BACKGROUND_PRIMARY_START"] = "#2B3B72";
    DS_COLOR["DARK_BACKGROUND_PRIMARY_END"] = "#1F54B2";
    DS_COLOR["DARK_BACKGROUND_SECONDARY_START"] = "#504CCB";
    DS_COLOR["DARK_BACKGROUND_SECONDARY_END"] = "#8482FF";
    /* MISC */
    DS_COLOR["DARK_DIVIDER"] = "#FFFFFF1F";
    DS_COLOR["DARK_OUTLINE_BORDER"] = "#FFFFFF3B";
    DS_COLOR["DARK_INPUT_LINE"] = "#FFFFFF6B";
    DS_COLOR["DARK_BACKDROP_OVERLAY"] = "#FFFFFF80";
    DS_COLOR["DARK_SNACKBAR_BACKGROUND"] = "#323232";
    DS_COLOR["DARK_BUTTON_LABEL_ICON"] = "#004881";
    DS_COLOR["DARK_FOCUS_OUTLINE"] = "#303030";
    /**
     * COMMON
     */
    DS_COLOR["BLACK_4P"] = "#0000000A";
    DS_COLOR["BLACK_12P"] = "#0000001F";
    DS_COLOR["BLACK_20P"] = "#00000033";
    DS_COLOR["BLACK_40P"] = "#00000066";
    DS_COLOR["BLACK_60P"] = "#00000099";
    DS_COLOR["BLACK_80P"] = "#000000CC";
    DS_COLOR["BLACK_100P"] = "#000000";
    DS_COLOR["WHITE_8P"] = "#FFFFFF14";
    DS_COLOR["WHITE_12P"] = "#FFFFFF1F";
    DS_COLOR["WHITE_20P"] = "#FFFFFF33";
    DS_COLOR["WHITE_30P"] = "#FFFFFF4D";
    DS_COLOR["WHITE_40P"] = "#FFFFFF66";
    DS_COLOR["WHITE_60P"] = "#FFFFFF99";
    DS_COLOR["WHITE_80P"] = "#FFFFFFCC";
    DS_COLOR["WHITE_100P"] = "#FFFFFF";
    DS_COLOR["GREY"] = "#F5F5F5";
    /* GRAPH */
    DS_COLOR["GRAPH_MINIMAL"] = "#75B8E7";
    DS_COLOR["GRAPH_MILD"] = "#77F094";
    DS_COLOR["GRAPH_MODERATE"] = "#F7FA81";
    DS_COLOR["GRAPH_MODERATE_SEVERE"] = "#FCC067";
    DS_COLOR["GRAPH_SEVERE"] = "#F07889";
    /* GRADIENT COLORS */
    DS_COLOR["LIGHT_GRADIENT_BACKGROUND_PRIMARY_TOP"] = "#E2F6FF";
    DS_COLOR["LIGHT_GRADIENT_BACKGROUND_PRIMARY_BOTTOM"] = "#FDF7F9";
    DS_COLOR["LIGHT_GRADIENT_BACKGROUND_SECONDARY_TOP"] = "#C2C1FF";
    DS_COLOR["LIGHT_GRADIENT_BACKGROUND_SECONDARY_BOTTOM"] = "#FFFBFF";
    DS_COLOR["LIGHT_GRADIENT_BACKGROUND_VIDEO_TOP"] = "#9E82F7";
    DS_COLOR["LIGHT_GRADIENT_BACKGROUND_VIDEO_BOTTOM"] = "rgba(0, 0, 0, 0)";
    DS_COLOR["LIGHT_GRADIENT_ICON_PRIMARY_TOP"] = "#4A93E5";
    DS_COLOR["LIGHT_GRADIENT_ICON_PRIMARY_BOTTOM"] = "#504CCB";
    DS_COLOR["LIGHT_GRADIENT_ICON_SECONDARY_TOP"] = "#504CCB";
    DS_COLOR["LIGHT_GRADIENT_ICON_SECONDARY_BOTTOM"] = "#8482FF";
    DS_COLOR["LIGHT_GRADIENT_HERO_TOP"] = "rgba(226, 246, 255, 0)";
    DS_COLOR["DARK_GRADIENT_BACKGROUND_HERO_TOP"] = "#294081";
    DS_COLOR["DARK_GRADIENT_BACKGROUND_PRIMARY_TOP"] = "#2B3B72";
    DS_COLOR["DARK_GRADIENT_BACKGROUND_PRIMARY_BOTTOM"] = "#1F54B2";
    DS_COLOR["DARK_GRADIENT_BACKGROUND_SECONDARY_TOP"] = "#504CCB";
    DS_COLOR["DARK_GRADIENT_BACKGROUND_SECONDARY_BOTTOM"] = "#8482FF";
    DS_COLOR["DARK_GRADIENT_BACKGROUND_VIDEO_TOP"] = "#353F77";
    DS_COLOR["DARK_GRADIENT_BACKGROUND_VIDEO_BOTTOM"] = "rgba(0, 0, 0, 0)";
    DS_COLOR["DARK_GRADIENT_ICON_PRIMARY_TOP"] = "#4A93E5";
    DS_COLOR["DARK_GRADIENT_ICON_PRIMARY_BOTTOM"] = "#504CCB";
    DS_COLOR["DARK_GRADIENT_ICON_SECONDARY_TOP"] = "#504CCB";
    DS_COLOR["DARK_GRADIENT_ICON_SECONDARY_BOTTOM"] = "#8482FF";
    DS_COLOR["DARK_GRADIENT_HERO_TOP"] = "rgba(39, 64, 128, 0)";
    DS_COLOR["GRADIENT_SHADER_LIGHT"] = "rgba(255, 255, 255, 0.72)";
    DS_COLOR["GRADIENT_SHADER_DARK"] = "rgba(0, 0, 0, 0.23)";
    DS_COLOR["CALM_GRADIENT_BRAND_TOP"] = "#60B4E7";
    DS_COLOR["CALM_GRADIENT_BRAND_BOTTOM"] = "#6461E0";
    DS_COLOR["CALM_GRADIENT_BRAND_ACCESSIBLE_TOP"] = "#2477AA";
    DS_COLOR["CALM_GRADIENT_BRAND_ACCESSIBLE_BOTTOM"] = "#6461E0";
})(DS_COLOR || (DS_COLOR = {}));
/** Available gradients, can be used in the background property */
export var DS_GRADIENT;
(function (DS_GRADIENT) {
    DS_GRADIENT["LIGHT_BACKGROUND_PRIMARY"] = "linear-gradient(180deg, #E2F6FF 0%, #FDF7F9 100%),linear-gradient(0deg, rgba(0, 0, 0, 0.23), rgba(0, 0, 0, 0.23))";
    DS_GRADIENT["LIGHT_BACKGROUND_SECONDARY"] = "linear-gradient(180deg, #C2C1FF 0%, #FFFBFF 100%),linear-gradient(0deg, rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0.72)),linear-gradient(0deg, rgba(0, 0, 0, 0.23), rgba(0, 0, 0, 0.23))";
    DS_GRADIENT["LIGHT_BACKGROUND_VIDEO"] = "linear-gradient(0deg, #9E82F7 0%, rgba(0, 0, 0, 0) 100%)";
    DS_GRADIENT["LIGHT_ICON_PRIMARY"] = "linear-gradient(135deg, #4A93E5 0%, #504CCB 100%)";
    DS_GRADIENT["LIGHT_ICON_SECONDARY"] = "linear-gradient(135deg, #504CCB 0%, #8482FF 100%)";
    DS_GRADIENT["LIGHT_HERO"] = "linear-gradient(180deg, rgba(226, 246, 255, 0) 0%, #E2F6FF 100%)";
    DS_GRADIENT["DARK_BACKGROUND_PRIMARY"] = "linear-gradient(180deg, #2B3B72 0%, #1F54B2 100%)";
    DS_GRADIENT["DARK_BACKGROUND_SECONDARY"] = "linear-gradient(180deg, #504CCB 0%, #8482FF 100%),linear-gradient(0deg, rgba(0, 0, 0, 0.23), rgba(0, 0, 0, 0.23))";
    DS_GRADIENT["DARK_BACKGROUND_VIDEO"] = "linear-gradient(0deg, #353F77 0%, rgba(0, 0, 0, 0) 100%)";
    DS_GRADIENT["DARK_ICON_PRIMARY"] = "linear-gradient(180deg, #4A93E5 0%, #504CCB 100%)";
    DS_GRADIENT["DARK_ICON_SECONDARY"] = "linear-gradient(180deg, #504CCB 0%, #8482FF 100%)";
    DS_GRADIENT["DARK_HERO"] = "linear-gradient(180deg, rgba(39, 64, 128, 0) 0%, #294081 100%)";
    DS_GRADIENT["CALM_HEALTH"] = "linear-gradient(252deg, rgba(200, 231, 255, 0.50) 0%, rgba(84, 132, 213, 0.00) 50%), linear-gradient(51deg, #BB91E9 1.06%, rgba(187, 145, 233, 0.00) 42.51%), linear-gradient(108deg, #4667C4 0%, #5286D7 49.48%, #7193DF 100%)";
    DS_GRADIENT["CALM_BRAND"] = "linear-gradient(180deg, #60B4E7 0%, #6461E0 100%)";
    DS_GRADIENT["CALM_BRAND_ACCESSIBLE"] = "linear-gradient(180deg, #2477AA 0%, #6461E0 100%)";
})(DS_GRADIENT || (DS_GRADIENT = {}));
//# sourceMappingURL=index.js.map